/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsExecuteLtxMatchesReportMutationRequest, AuditReportsExecuteLtxMatchesReportMutationResponse, AuditReportsExecuteLtxMatchesReportQueryParams, AuditReportsExecuteLtxMatchesReport400, AuditReportsExecuteLtxMatchesReport401, AuditReportsExecuteLtxMatchesReport403, AuditReportsExecuteLtxMatchesReport500 } from "../models/AuditReportsExecuteLtxMatchesReport";

export function getAuditReportsExecuteLtxMatchesReportUrl() {
  const res = { method: 'POST', url: `/audit-reports/v1/reports/ltx-matches/results` as const }
  return res
}

/**
 * @summary Generate report results
 * {@link /audit-reports/v1/reports/ltx-matches/results}
 */
export async function auditReportsExecuteLtxMatchesReport(data: AuditReportsExecuteLtxMatchesReportMutationRequest, params?: AuditReportsExecuteLtxMatchesReportQueryParams, config: Partial<RequestConfig<AuditReportsExecuteLtxMatchesReportMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<AuditReportsExecuteLtxMatchesReportMutationResponse, ResponseErrorConfig<AuditReportsExecuteLtxMatchesReport400 | AuditReportsExecuteLtxMatchesReport401 | AuditReportsExecuteLtxMatchesReport403 | AuditReportsExecuteLtxMatchesReport500>, AuditReportsExecuteLtxMatchesReportMutationRequest>({ method : "POST", url : getAuditReportsExecuteLtxMatchesReportUrl().url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}